import { CollectionType } from '@enums/CollectionType';
import { ContentType } from '@models/Content';

import { IconOption } from '../Icon';

export const ContentTypeIconMap: Record<ContentType, IconOption> = {
  [CollectionType.CHERRY_PICK]: 'cherry',
  [CollectionType.QUERY]: 'search',
  collection: 'videoLibrary',
  grid: 'grid',
  image: 'image',
  link: 'link',
  menu: 'menu',
  page: 'description',
  pageSection: 'pageSection',
  rootMenu: 'rootMenu',
  swimlane: 'swimlane',
  title: 'movie',
  unmanaged: 'magic',
};
